export default __webpack_public_path__ + "static/media/chikn.d1f677e8.png";